import angular from 'angular';
import $ from 'jquery';

angular.module('app.ctrls')
    .controller('crmServiceController', ['$rootScope', '$scope', '$state', '$q', '$modal', 'UserService', '$ioAlert', 'CrmConnectionsService', 'ClusterService', function($rs, $scope, $state, $q, $modal, UserService, $ioAlert, CrmConnectionsService, ClusterService) {
        $scope.connections = [];
        $scope.clusters = null;
        $scope.test = null;
        $scope.loadFail = false;
        $scope.fieldMappings = {};
        $scope.serviceName = null;
        $scope.notify = [];
        $scope.kickOff = [];
        $scope.connectionClones = [];

        init();

        var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
            getServiceConnections(ClusterService.clusterId);
        });

        $scope.$on('$destroy', function() {
            clusterSelector();
        });

        $scope.clusterName = function(id) {
            if($scope.clusters){
                for(var i = 0; i < $scope.clusters.length; i++){
                    if($scope.clusters[i].id === id){
                        return $scope.clusters[i].name;
                    }
                }
            }
        }

        $scope.dirty = function(key, field) {
            if (field === 'notification_to' || field === 'cluster_id') {
                if ($scope.connections[key][field] !== $scope.connectionClones[key][field]) {
                    $scope.dirtyField = true;
                } else {
                    $scope.dirtyField = false;
                }
            } else if (field === 'kickOff') {
                $scope.dirtyField = $scope.kickOff[key] === true ? true : false;
            } else if (field === 'notify') {
                if($scope.notify[key] !== ($scope.connectionClones[key].notification_to !== '' ? true : false)) {
                    $scope.dirtyField = true;
                    $scope.connections[key].notification_to = '';
                } else {
                    $scope.dirtyField = false;
                    $scope.connections[key].notification_to = $scope.connectionClones[key].notification_to;
                }
            } else {
                if($scope.connections[key].field_mapping[field] !== $scope.connectionClones[key].field_mapping[field]) {
                    $scope.dirtyField = true;
                } else {
                    $scope.dirtyField = false;
                }
            }
        }

        $scope.updateStatus = function(connection, key) {
            CrmConnectionsService.updateConnectionStatus(connection).then(function() {
                $ioAlert.show('', 'Status changed!', 'success');
                $scope.connections[key].status = CrmConnectionsService.status.result.status;
            }, function(error) {
                $ioAlert.show('Error!', 'An error occurred while trying to change your connection status.', 'error');
            });
        }

        function showConnectionModal() {
            return $modal.open({
                controller: function($scope, $modalInstance, clusters, id) {
                    $scope.clusters = clusters;
                    $scope.addConnection = function(connectionForm) {
                        if(connectionForm.$valid){
                            var userData = JSON.stringify({"username": $scope.userName, "password": $scope.password, "security_token": $scope.securityToken});
                            var formObj = {service_id: id, name: $scope.name, user_data: userData, cluster_id: $scope.cluster.id};
                            CrmConnectionsService.testConnection(formObj).then(function() {
                                if(!CrmConnectionsService.test) {
                                    $ioAlert.show('Error!', 'Please fix your credentials and try again', 'error');
                                } else {
                                    $modalInstance.close(formObj);
                                }

                            }, function(error) {
                                $ioAlert.show('Error!', 'An error occurred while trying to test your connection, please try again.', 'error');
                            });
                        }
                    };
                    $scope.testConnection = function() {
                        if($scope.userName && $scope.password) {
                            var userData = JSON.stringify({"username": $scope.userName, "password": $scope.password, "security_token": $scope.securityToken});
                            var testObj = {service_id: id, user_data: userData};
                            CrmConnectionsService.testConnection(testObj).then(function() {
                                if(CrmConnectionsService.test) {
                                    $ioAlert.show('', 'Valid Credentials', 'success');
                                } else {
                                    $ioAlert.show('Error!', 'Please fix your credentials and try again', 'error');
                                }

                            }, function(error) {
                                $ioAlert.show('Error!', 'An error occurred while trying to test your connection, please try again.', 'error');
                            });
                        } else {
                            $ioAlert.show('Error!', 'Please enter a user name and password', 'error');
                        }
                    };
                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }
                },
                templateUrl: 'views/admin/createConnection.html',
                resolve: {
                    clusters: function() {
                        return $scope.clusters;
                    },
                    id: function() {
                        return $state.params.id;
                    }
                },
                backdrop: 'static'
            });
        };

        $scope.addServiceConnection = function() {
            $scope.lockedButton = true;
            ClusterService.setClusters().then(function(){
                $scope.clusters = ClusterService.clusters;
                showConnectionModal().result.then(function(formObj) {
                    CrmConnectionsService.addServiceConnection(formObj).then(function(data) {
                        $scope.lockedButton = false;
                        var connection = angular.copy(CrmConnectionsService.connection)
                        connection.field_mapping = JSON.parse(connection.field_mapping);
                        $scope.connectionClones.push(angular.copy(connection));
                        $scope.connections.push(connection);
                        $ioAlert.show('', 'Service connection added successfully', 'success');
                    }, function(error) {
                        $scope.lockedButton = false;
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    })
                }, function(cancel) {
                    $scope.lockedButton = false;
                })
            })
        };

        $scope.saveForm = function(key) {
            //manual validation is necessary here due to an inability to pass in ng-repeated unique forms
            if($scope.connections[key].cluster_id && $scope.connections[key].field_mapping.name && $scope.connections[key].field_mapping.crm_id){
                
                //reset the send notifications in the case where it is selected and the form field is blank, do not trigger notify on blank
                if($scope.notify[key] && (!$scope.connections[key].notification_to || $scope.connections[key].notification_to.replace(/\s/g, '') === '')) {
                    $scope.notify[key] = false;
                    $scope.connections[key].notification_to = null;
                }
                //update
                CrmConnectionsService.updateServiceConnection($scope.connections[key]).then(function(){
                    $scope.connectionClones[key] = angular.copy(CrmConnectionsService.connection);
                    $scope.connectionClones[key].field_mapping = JSON.parse($scope.connectionClones[key].field_mapping);
                    $scope.connections[key] = angular.copy($scope.connectionClones[key]);
                    $ioAlert.show('', 'Service connection updated successfully', 'success');
                    $scope.dirtyField = false;
                    
                    //kick off the update import if checked
                    if($scope.kickOff[key]) {
                        CrmConnectionsService.kickOffUpdateImport($scope.connections[key].id)
                    }
                });
            }
        };

        function genFieldMapping(id) {
          //  CrmConnectionsService.mappingByServiceId(id).then(function(){
                for(var i = 0; i < $scope.connections.length; i++) {
                    $scope.connections[i].field_mapping = JSON.parse($scope.connections[i].field_mapping);
                    $scope.connectionClones[i].field_mapping = angular.copy($scope.connections[i].field_mapping);
                    $scope.notify[i] = $scope.connectionClones[i].notification_to !== '' ? true : false;
                }
             //   $scope.fieldMappings = CrmConnectionsService.mappings;
           // });
        };

        function getServiceConnections(clusterId) {
            CrmConnectionsService.connectionsByServiceId($state.params.id, clusterId).then(function() {
                $scope.connections = CrmConnectionsService.connections;
                $scope.connectionClones = angular.copy($scope.connections);
                $scope.clientsLoader = false;
                genFieldMapping($state.params.id);
            }, function(error) {
                $scope.clientsLoader = false;
                $scope.loadFail = true;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        };

        $scope.toggle = function(ev, key) {
            $(ev.target).siblings(':last').slideToggle(200);
            if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.target).removeClass('fa-chevron-right');
                $(ev.target).addClass('fa-chevron-down');

                //iterate the mapping props on the connection, compare for stale data on close and restore form if true
                for (var mapping in $scope.connections[key].field_mapping) {
                    if($scope.connections[key].field_mapping.hasOwnProperty(mapping)){
                        if($scope.connections[key].field_mapping[mapping] !== $scope.connectionClones[key].field_mapping[mapping]) {
                            $scope.connections[key].field_mapping[mapping] = angular.copy($scope.connectionClones[key].field_mapping[mapping]);
                        }
                    }
                }

                $scope.notify[key] = $scope.connectionClones[key].notification_to ? true : false;
                $scope.connections[key].notification_to = angular.copy($scope.connectionClones[key].notification_to);
                $scope.kickOff[key] = false;
            } else {
                $(ev.target).removeClass('fa-chevron-down');
                $(ev.target).addClass('fa-chevron-right');
            }
        };

        function getService(){
            if(!$state.params.serviceName) {
                CrmConnectionsService.fetchService($state.params.id).then(function() {
                    $scope.serviceName = CrmConnectionsService.service.services.name;
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong fetching your service.', 'error');
                })
            } else {
                $scope.serviceName = $state.params.serviceName;
            }
        }

        function init() {
            getService();
            getServiceConnections();
            ClusterService.setClusters().then(function(){
                $scope.clusters = ClusterService.clusters;
            });
        };
    }]);
